import React from 'react'
import { IconCircle, IconCircleCheck } from '@tabler/icons-react'
import Typography from './Typography'
import { cn } from 'src/enviroment/lib/utils'

const STRENGTH_COLORS = ['bg-red-ramo', 'bg-light-green-500']

// mirrors the `newPassword` rules in enviroment/validation/fields.ts
const requirements = [
  {
    label: 'At least 12 characters (upper and lower cased)',
    test: (v: string) => v.length >= 12 && /[A-Z]/.test(v) && /[a-z]/.test(v) && !/\s/.test(v),
  },
  { label: 'A number or a symbol', test: (v: string) => /[\d\W_]/.test(v) },
]

interface PasswordStrengthIndicatorProps {
  value: string
  /** Expands the panel once the user reaches the password field. */
  open?: boolean
  className?: string
}

const PasswordStrengthIndicator: React.FC<PasswordStrengthIndicatorProps> = ({ value, open = true, className }) => {
  const results = requirements.map((requirement) => requirement.test(value))
  const met = results.filter(Boolean).length

  if (!open) return null

  return (
    <div className={cn('animate-fade-in-up', className)}>
      <div className="space-y-2 pt-2">
        <div className="flex items-center gap-3">
          <div className="flex flex-1 gap-2">
            {requirements.map((requirement, index) => (
              <div
                key={requirement.label}
                className={cn(
                  'h-1 flex-1 rounded-full transition-colors duration-200',
                  index < met ? STRENGTH_COLORS[met - 1] : 'bg-gray-700',
                )}
              />
            ))}
          </div>
          <Typography variant="xs" className="shrink-0 text-gray-400">
            Strength
          </Typography>
        </div>

        <ul className="space-y-1">
          {requirements.map((requirement, index) => (
            <li key={requirement.label} className="flex items-center gap-2">
              {results[index] ? (
                <IconCircleCheck className="h-4 w-4 shrink-0 text-light-green-500" stroke={1.5} />
              ) : (
                <IconCircle className="h-4 w-4 shrink-0 text-gray-500" stroke={1.5} />
              )}
              <Typography variant="xs" className={results[index] ? 'text-light-green-500' : 'text-gray-400'}>
                {requirement.label}
              </Typography>
            </li>
          ))}
        </ul>
      </div>
    </div>
  )
}

export default PasswordStrengthIndicator
